export const styleTitle = { color: 'rgb(103, 104, 108)', fontWeight: 'normal' }
